<template>
  <div>
    <b-modal
      title="DETALHES DA VENDA"
      id="details"
      size="lg"
      hide-footer
      no-close-on-backdrop
    >
      <details-stock-sale :stock_sale="stock_sale" />
    </b-modal>
    <Filters @paginate="handleFilters" :loading="loading" />
    <b-overlay :show="loading" opacity="0.99">
      <div v-show="data.length === 0" class="v-clean p-5">
        <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
      </div>
      <v-data-table
        v-show="data.length > 0"
        dense
        :headers="headers"
        :items="data"
        :footer-props="{
          'items-per-page-options': [50, 75, 100],
          'items-per-page-text': 'Mostrar',
        }"
        :options.sync="options"
        :server-items-length="total"
      >
        <template v-slot:[`item.status`]="{ item }">
          <small class="mr-2">ATRASADO</small>
          <v-icon color="warning" small>mdi-clock-outline</v-icon>
          <input type="hidden" :value="item.status" />
        </template>
        <template v-slot:[`item.medicine_product`]="{ item }">
          {{
            item.stock_item_type == "MEDICINE"
              ? item.medicine_name
              : item.product_name
          }}
        </template>
        <template v-slot:[`item.stock_group`]="{ item }">
          {{ item.stock_group_name }}
        </template>
        <template v-slot:[`item.amount`]="{ item }">
          {{ item.amount }}
          {{ item.stock_item_unit_of_measurement_abbreviation }}
        </template>
        <template v-slot:[`item.value`]="{ item }">
          {{
            formatPrice(
              item.finance_launch_bills_to_pay_installments_item_value
            )
          }}
        </template>
        <template v-slot:[`item.entry_date`]="{ item }">
          {{ moment(item.entry_date).format("DD/MM/YYYY") }}
        </template>
        <template v-slot:[`item.due_date`]="{ item }">
          {{ formatDate(item.due_date, false) }}
        </template>
        <template v-slot:[`item.details`]="{ item }">
          <v-btn x-small class="btn-primary m-1" @click="handleDetails(item)">
            <i class="fas fa-eye mr-2"></i>DETALHES
          </v-btn>
        </template>
      </v-data-table>
    </b-overlay>
    <ErrorsMessages :errors="errors" />
  </div>
</template>

<script>
import ErrorsMessages from "../../Components/ErrorsMessages.vue";

import Filters from "../../Components/Filters.vue";

import DetailsStockSale from "./launch/details.vue";

import api from "../../../services/api";

import routes from "../../../routes";

import { formatPrice, formatDate } from "../../../lib/format";

import moment from "moment";

import permission from "../../../lib/permission";

export default {
  name: "Late",

  components: {
    ErrorsMessages,
    Filters,
    DetailsStockSale,
  },

  props: {
    resident: Object,
  },

  data() {
    return {
      month: moment().format("YYYY-MM"),
      dayMonthYear: "month",

      status: 2,

      resident_id: "",

      total: 0,
      options: {},

      headers: [
        { text: "STATUS", value: "status", sortable: false },
        {
          text: "MEDICAMENTO/PRODUTO",
          value: "medicine_product",
          sortable: false,
        },
        { text: "GRUPO", value: "stock_group", sortable: false },
        { text: "LOTE", value: "lot", sortable: false },
        { text: "QTD", value: "amount", sortable: false },
        { text: "VALOR", value: "value", sortable: false },
        { text: "DATA DA VENDA", value: "entry_date", sortable: false },
        { text: "VENCIMENTO", value: "due_date", sortable: false },
        { text: "DETALHES", value: "details", sortable: false },
      ],

      data: [],
      stock_sale: {},

      loading: false,

      errors: [],
    };
  },

  watch: {
    options: {
      handler() {
        this.paginate();
      },
    },
  },

  created() {
    this.retrieve();
  },

  methods: {
    moment,
    formatPrice,
    formatDate,
    permission,

    retrieve() {
      const { id } = routes.history.current.params;

      this.resident_id = id;

      this.paginate();
    },

    handleFilters(filters) {
      let { month, dayMonthYear } = filters;

      this.month = month;
      this.dayMonthYear = dayMonthYear;

      this.paginate();
    },

    handleDetails(stock_sale) {
      this.stock_sale = stock_sale;
      this.$bvModal.show("details");
    },

    async paginate() {
      try {
        this.loading = true;

        let { resident_id, status, month, dayMonthYear } = this;

        const { page, itemsPerPage } = this.options;

        let params = {
          resident_id,
          status,
          page,
          itemsPerPage,
          late: true,
          month,
          dayMonthYear,
        };

        const response = await api.get(
          "/rest-home/family/financial-menu-rest-home-sales-resident",
          {
            params,
          }
        );

        const { error, errors, data, total } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.data = data;
          this.total = total;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
